// JS for Help me choose
import $ from 'jquery'

$(document).on('gform_page_loaded', function(event, form_id, current_page) {

	function move_progress_bar_to_bottom() {
		if (current_page != 1) {
			$('div#gf_progressbar_wrapper_' + EAPLUS_VARS.hmc_wizard_form_id).each(function(i, e) {
				var progressBar = $('<div>').append($(e).clone()).remove().html();
				$('div#gform_wrapper_' + EAPLUS_VARS.hmc_wizard_form_id + ' .gform_page:visible .gform_page_fields').append(progressBar);
				$(e).remove();
			});
		}
	}

	function move_form_footer() {
		if (current_page == 5) {
			var formFooter = $('div#gform_wrapper_' + EAPLUS_VARS.hmc_wizard_form_id + ' .gform_page:visible .gform_page_footer');
			$('div#gform_wrapper_' + EAPLUS_VARS.hmc_wizard_form_id + ' div#lead-form').append(formFooter);
			$('div#gform_wrapper_' + EAPLUS_VARS.hmc_wizard_form_id + ' .gform_page:visible .gform_previous_button').hide();
			}
	}

	if (form_id == EAPLUS_VARS.hmc_wizard_form_id) {
		move_progress_bar_to_bottom();
		move_form_footer();
	}

});
